module.exports = __webpack_public_path__ + "static/media/pungo.d6c39fcd.svg";